'use strict';

class BewaAgency {
  constructor(originatorService, invoiceService, Notification) {
    this.originatorService = originatorService;
    this.invoiceService = invoiceService;
    this.Notification = Notification;
  }

  $onInit() {
    this.creditors = [];
    this.creditor = {
      name: this.accountIntegrations.originator.name,
      email: this.accountIntegrations.originator.contact.email,
      phone: this.accountIntegrations.originator.contact.phone,
      organisationNumber: this.accountIntegrations.originator.organisation.number,
      includeTax: false,
      acceptEula: false,
      collectionAgency: 'BEWA'
    };
    this.status = false;
    this.agencies = this.originatorService.collectionAgencies;

    this.I18N = {
      INIT: 'Under registrering',
      NOT_REGISTERED: 'Under registrering',
      REGISTERED: 'Aktiv',
      CLOSED: 'Deaktivert',
      AWAITING_FIRST_CASE: 'Avventer oversendelse av første sak'
    };

    this.load();
  }

  load() {
    this.originatorService.getCreditors()
      .then((resp) => {
        if (resp.data && resp.data.length) {
          this.creditors = resp.data
            .filter((item) => item.collectionAgency === 'BEWA')
            .map((item) => {
              if (item.organisationNumber === this.accountIntegrations.originator.organisation.number) {
                this.status = true;
                this.agencies.push('BEWA');
              }

              return item;
            });
        }
      });
  }

  register() {
    this.invoiceService.registerCreditor(this.creditor)
      .then(() => {
        this.load();
        //refresh settings
        this.accountIntegrations.settings.defaults.collectionAgency = this.creditor.collectionAgency;
        this.originatorService.getForce();
      });
  }
}

BewaAgency.$inject = ['originatorService', 'invoiceService', 'Notification'];

const bewaAgency = {
  controller: BewaAgency,
  require: {
    accountIntegrations: '^^accountIntegrations'
  },
  template: `
    <fieldset ng-show="$ctrl.status" ng-form="registerCreditor_BEWA">
      <div class="row">
        <div class="large-3 columns">
          <img src="/assets/img/collectia.png" alt="COLLECTIA" />
        </div>

        <div class="large-9 columns">
          <p>
          Med inkassotjenester fra <a href="https://collectiagroup.no/" target="_blank" rel="nofollow">Collectia AS</a> (tidl. Equity Finans AS), kan du være sikker på at dine kundefordringer er godt ivaretatt til en riktig pris. Din bedrift vil oppnå raskere betaling og bedre kundetilfredshet.
          </p>
          <p>
            <span ng-hide="$ctrl.status">Før du kan sende regningen din til inkasso må du inngå en avtale med COLLECTIA ved å fylle inn skjemaet under.</span>
          </p>
          <p>
            Det er gratis å overføre saker til COLLECTIA, i tillegg kommer <a href="/files/Priser_Collectia.pdf" target="_blank" rel="nofollow">COLLECTIAs priser</a>.
          </p>
        </div>
      </div>

      <hr ng-show="$ctrl.creditors.length">

      <table ng-show="$ctrl.creditors.length">
        <thead>
          <tr>
            <th>Kundenummer</th>
            <th>Organisasjonsnummer</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="creditor in $ctrl.creditors track by $index">
            <td>{{ creditor.kNumber }}</td>
            <td>{{ creditor.organisationNumber }}</td>
            <td>{{ $ctrl.I18N[creditor.state] }}</td>
          </tr>
        </tbody>
      </table>

      <p>Etter at avtalen er inngått vil COLLECTIA registrere deg som kunde i sine systemer, når tjenesten er klar for bruk vil du motta en velkomstmail. Dersom det står at du er registrert, men du ikke har mottatt noen velkomstmail, bør du kontakte <a href="mailto:kundesenter@collectiagroup.no">kundesenter@collectiagroup.no</a> og oppgi kundenummeret over.</p>

    </fieldset>
  `
};

angular
  .module('SendRegning')
  .component('bewaAgency', bewaAgency);
